// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blog{margin-bottom:5rem}.blog .h1{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
